module.exports = __webpack_public_path__ + "static/media/012_CallSalesRepwithmultipleorders@2x.61523dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/012_CallSalesRepwithmultipleorders@2x.png
// module id = 575
// module chunks = 0